export default [
  {
    path: '/payment-invoices',
    name: 'PagePaymentInvoicesList',
    meta: {
      title: 'paymentInvoices.listTitle',
      permissions: ['mira_payment_invoice_view'],
      roles: ['ADMIN', 'TEAM_LEADER'],
    },
    component: () => import('@/pages/payment-invoices'),
  },
  {
    path: '/payment-invoices/create',
    name: 'PagePaymentInvoicesCreate',
    meta: {
      title: 'paymentInvoices.createFormTitle',
      permissions: ['mira_payment_invoice_edit'],
      roles: ['ADMIN', 'TEAM_LEADER'],
    },
    component: () => import('@/pages/payment-invoices/create'),
  },
  {
    path: '/payment-invoices/:id/edit',
    name: 'PagePaymentInvoicesEdit',
    meta: {
      title: 'paymentInvoices.editFormTitle',
      // edit page is read-only for a saved invoice (CPA-3558), so view permission is enough
      permissions: ['mira_payment_invoice_view'],
      roles: ['ADMIN', 'TEAM_LEADER'],
    },
    component: () => import('@/pages/payment-invoices/id/edit'),
  },
]
